import React, {ReactElement} from 'react';
import {useSelector} from 'react-redux';
import {selectedPresentationSelector} from '../../../../store/selectors/presentation.selectors';
import {IQuestionReportElement} from '../../../../incase-domain/elements/question/questionReportElement';
import {IQuestionElementProps} from '../../../../incase-domain/elements/base/questionElementBase';
import {IQuestionElements} from '../../../../incase-domain/elements/question';
import {IElementTextInput} from '../../../../incase-domain/elements/textInput';
import RenderQuestionReport from './RenderQuestionReport';

function QuestionReportElement({element, device}: IQuestionElementProps<IQuestionReportElement>): ReactElement {
    const {fontFamily} = element;
    const presentation = useSelector(selectedPresentationSelector);

    const slide = presentation?.slides?.find((slide) => slide.elements.find((el) => el.id === element.questionElementId));

    const question = slide?.elements.find((el) => el.id === element.questionElementId) as IQuestionElements | IElementTextInput | undefined;

    return (
        <RenderQuestionReport
            question={question}
            slide={slide}
            fontFamily={fontFamily}
            device={device}
            palette={element.wordCloudPalette}
        />
    );
}

export default QuestionReportElement;
